import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { model } from './model'; 
import { initialize } from './controller';
import SiteBreadcrumb from '@/components/SiteBreadcrumb';
import { getThisAndNextWeekDesc, hexFromStr,invertColor, numberToColor } from '@/utils/S';
import './index.less'; 
import { globalStore, load } from '@/common/index';
import { useNavigate } from 'react-router-dom';

const View: React.FC = observer(() => {

  useEffect(() => {
     initialize();
  }, []);

  const navigate = useNavigate();

  if (globalStore.sessionChecked && !globalStore.isLogin) {
    navigate('/login');
  }

  const goToBugPage = ()=>{
    globalStore.bugFilterUserId = globalStore.currentUser.id
    navigate("/bug");
  }

  const weekDesc = getThisAndNextWeekDesc();


  if (model.homeLoadError) {
    return <div style={{ padding: 24 }}>工作台加载失败：{model.homeLoadError}</div>;
  }

  if (!globalStore.isLoaded || !model.homeData) {
    return <div style={{ padding: 24 }}>Loading...</div>;
  }
 
  return (
    <div className="home-page"> 
        <SiteBreadcrumb name="工作台" />
        <div className="home-page-card">
            <div style={{padding:'20px 10px'}}>指南针</div>
            <div style={{display:'flex', flexDirection:'row'}}>
              <div  style={{ flex:'1'}}>
                <div onClick={()=>navigate("/demand")} className='summary_item_card' style={{ backgroundColor:numberToColor(model.homeData.waitForProcessDemandCount), color:invertColor(numberToColor(model.homeData.waitForProcessDemandCount))}}>
                      <div className='summary_item_title'>待处理需求</div>
                      <div style={{padding:'0px 10px', textAlign:'center'}}>
                          <span style={{ fontSize:'24px', fontWeight:'500'}}>{ model.homeData.waitForProcessDemandCount }</span>
                          <span style={{ fontSize:'12px', marginLeft:'5px', fontWeight:'200'}}>个</span>
                      </div>
                </div>
              </div>
              <div style={{ flex:'1'}}>
                <div onClick={()=>navigate("/project")} className='summary_item_card' style={{ backgroundColor: numberToColor(model.homeData.inProgressProjectCount), color:invertColor(numberToColor(model.homeData.inProgressProjectCount))}}>
                      <div className='summary_item_title'>进行中项目</div>
                      <div style={{padding:'0px 80px'}}>
                          <span style={{ fontSize:'24px', fontWeight:'500'}}>{ model.homeData.inProgressProjectCount }</span>
                          <span style={{ fontSize:'12px', marginLeft:'5px', fontWeight:'200'}}>个</span>
                      </div>
                </div>
              </div>
              <div style={{ flex:'1'}}>
                <div onClick={()=>navigate("/delivery")}  className='summary_item_card' style={{ backgroundColor:numberToColor(model.homeData.waitForDeliverTaskCount), color:invertColor(numberToColor(model.homeData.waitForDeliverTaskCount))}}>
                      <div className='summary_item_title'>待处理交付项</div>
                      <div style={{padding:'0px 80px'}}>
                          <span style={{ fontSize:'24px', fontWeight:'500'}}>{ model.homeData.waitForDeliverTaskCount }</span>
                          <span style={{ fontSize:'12px', marginLeft:'5px', fontWeight:'200'}}>个</span>
                      </div>
                </div>
              </div>
              <div style={{ flex:'1'}}>
                <div  onClick={goToBugPage}  className='summary_item_card' style={{ backgroundColor:numberToColor(model.homeData.waitForFixBugCount), color:invertColor(numberToColor(model.homeData.waitForFixBugCount))}}>
                      <div  className='summary_item_title'>本周待处理缺陷</div>
                      <div style={{padding:'0px 80px'}}>
                          <span style={{ fontSize:'24px', fontWeight:'500'}}>{ model.homeData.waitForFixBugCount }</span>
                          <span style={{ fontSize:'12px', marginLeft:'5px', fontWeight:'200'}}>个</span>
                      </div>
                </div>
              </div> 
            </div>
            <div style={{padding:'20px 10px', marginTop:'20px'}}>可视化晨会周览</div> 
            <div style={{display:'flex', flexDirection:'row'}}>
                <div style={{ flex:'1'}}>
                    <div style={{display:'flex',flexDirection:'column',margin:'auto',width:'300px'}}>
                      <div style={{ flex:'1'}}>
                        <div className='meeting_title'>本周（{weekDesc.currentWeek}）</div>
                      </div>
                      {
                          model.homeData.thisWeekMeetings.map((meeting, index) => (
                            <div key={index} style={{ flex: '1' }}>
                              <div className='meeting' style={{ color: invertColor(hexFromStr(meeting.name)), backgroundColor: hexFromStr(meeting.name)}}>{ meeting.name }</div>
                            </div>
                          ))
                      }
                      </div>
                </div>
                <div style={{ flex:'1'}}>
                    <div style={{display:'flex',flexDirection:'column',margin:'auto',width:'300px'}}>
                      <div style={{ flex:'1'}}>
                        <div className='meeting_title'>下周（{weekDesc.nextWeek}）</div>
                      </div>
                      {
                          model.homeData.nextWeekMeetings.map((meeting, index) => (
                            <div key={index} style={{ flex: '1'}}>
                              <div  className='meeting' style={{ color: invertColor(hexFromStr(meeting.name)), backgroundColor: hexFromStr(meeting.name)}}>{ meeting.name }</div>
                            </div>
                          ))
                      }
                    </div>
                </div>
            </div>
        </div> 
    </div>
    
  );
});

export default View;
